import { render, staticRenderFns } from "./printContent.vue?vue&type=template&id=2b3b3b85&scoped=true&"
import script from "./printContent.vue?vue&type=script&lang=js&"
export * from "./printContent.vue?vue&type=script&lang=js&"
import style0 from "./printContent.vue?vue&type=style&index=0&id=2b3b3b85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b3b85",
  null
  
)

export default component.exports